import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { staffApi } from '../../lib/staffApi';
import { ArticleView } from '../../components/content/ArticleView';

export default function PrivatePreview() {
  const {id} = useParams(); const [item, setItem] = useState(null); const [error, setError] = useState('');
  useEffect(() => {let active = true; staffApi(`/staff/content/${id}`).then(data => {if (active) setItem(data);}).catch(e => {if (active) setError(e.message);}); return () => {active = false;};}, [id]);
  if (error) return <p role="alert" className="staff-error" data-testid="private-preview-error">{error}</p>;
  if (!item) return <p data-testid="private-preview-loading">Loading private preview…</p>;
  return <><div className="staff-notice" data-testid="private-preview-banner">Private staff preview. This does not publish or approve the content.</div><ArticleView item={item} preview /></>;
}